/**
 * Brings the first invalid field of a form into view: scrolls it to the centre
 * of the screen and focuses it. "First" is page order, taken from the fields'
 * `aria-invalid` state, which every error state of the form sets (MUI inputs
 * and the street search alike), so it needs to know no field names. Returns the
 * field, or `null` when none is invalid.
 */
export function focusFirstInvalidField(
  root: HTMLElement | null
): HTMLElement | null {
  const field = root?.querySelector<HTMLElement>(
    '[aria-invalid="true"]:not(:disabled)'
  );
  if (!field) {
    return null;
  }
  field.scrollIntoView({ block: "center", behavior: "smooth" });
  // The smooth scroll above is the one that moves the page.
  field.focus({ preventScroll: true });
  return field;
}
